import { MQ } from '@common/constants/mq.constant';
import { THEME } from '@common/constants/theme.constant';
import { SerializedStyles } from '@emotion/react';
import { LayoutFooter } from '@src/shared/layout/layout-footer.component';
import React from 'react';
import { css } from 'twin.macro';

export enum ELayoutWidth {
    normal = 'normal',
    large = 'large',
    extraLarge = 'extraLarge',
}
export interface ILayoutProps {
    content?: JSX.Element | JSX.Element[] | null;
    className?: string;
    contentCss?: SerializedStyles;
    desktopLeftSide?: JSX.Element | JSX.Element[] | null;
    desktopRightSide?: JSX.Element | JSX.Element[] | null;
    header?: JSX.Element | JSX.Element[] | null;
    footer?: JSX.Element | JSX.Element[] | null;
    maxWidth?: string;
}

export const Layout = ({
    content,
    className,
    desktopLeftSide,
    desktopRightSide,
    header,
    footer,
    maxWidth = THEME.MAX_WIDTH,
    contentCss,
}: ILayoutProps): JSX.Element => {
    return (
        <div data-testid="layout" css={styles.root} className={className}>
            {header ? <div>{header}</div> : null}

            <div css={[styles.content(maxWidth), contentCss]}>
                {desktopLeftSide ? <div css={styles.desktopLeftMenu}>{desktopLeftSide}</div> : null}

                <div css={styles.contentChild}>{content}</div>
                {desktopRightSide ? <div css={styles.desktopRightSide}>{desktopRightSide}</div> : null}
            </div>
            {footer !== undefined ? footer : <LayoutFooter />}
        </div>
    );
};

const styles = {
    root: css`
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    `,

    desktopLeftMenu: css`
        display: none;
        min-width: ${THEME.LEFT_MENU_WIDTH};
        max-width: ${THEME.LEFT_MENU_WIDTH};
        padding-right: 24px;
        padding-top: 16px;

        ${MQ.lg} {
            display: block;
        }
    `,
    desktopRightSide: css`
        display: none;
        min-width: ${THEME.RIGHT_MENU_WIDTH};
        max-width: ${THEME.RIGHT_MENU_WIDTH};
        padding-left: 12px;

        ${MQ.xxl} {
            display: block;
        }
    `,

    content: (maxWidth: string): SerializedStyles[] => [
        css`
            flex: 1 1 auto;
            background-color: white;
            display: flex;
            padding: 0px 16px;
            padding-bottom: 16px;
            ${MQ.lg} {
                width: 100%;
                padding: 0px;
                padding-bottom: 40px;
                max-width: ${maxWidth};
                margin: 0 auto;
            }
        `,
    ],

    contentChild: css`
        flex: 1 1 auto;
    `,
};
